import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { List, Map, fromJS } from 'immutable';

import {APARTMENTS, SALE, RENT, VIEW_MODE, ADFOX} from '../../../consts';
import { DEFAULT_FILTER } from '../filter';

import { getUser } from '../../User/actions';
import { setSection } from '../../Dictionaries/actions';
import { getCianRedirectUrl } from '../../Home/actions';
import {
  resetFilter, updateFilter, setFilterByLocation,
  loadAnnouncement, fetchAnnouncement, loadCountAnnouncement,
  fetchAgencies, updateAutocompleteOptions,
} from '../actions';

import {
  eventAddFavorites,
  eventRemoveFavorites,
  eventMapModal,
  eventOpenClaimForm,
  eventOpenCommentForm,
  eventSaveSearch,
  eventSubscription,
  eventShowContacts
} from '../events';

import { loadAnnouncement as loadAnnouncementMap } from '../../Maps/actions';
import getDictionary from '../../../utils/dictionaries';
import {getPrevRelPage, getNextRelPage, getLocationByFilter} from '../../../utils/urls';
import { getCellSearchFactory } from '../../../classes/builder/search/cellFactoryBuilder';
import { getTableSearchFactory } from '../../../classes/builder/search/tableFactoryBuilder';
import { getListItem } from '../../../classes/builder/mapListBuilder';
import { getFlexItem } from '../../../classes/builder/search/flexListBuilder';

import ReactPaginate from 'react-paginate';
import { ScrollToTopOnMount, FixedBody, FixedMenu } from '../../../ui/Common';
import connectDataFetchers from '../../../lib/connectDataFetchers';
import {GridView, MapView, ListView, FlexView} from '../../../ui/Views/Announcements';
import {SoldAnnouncement, SeoText, AdFoxWideScreen} from '../../../ui/Widgets';
import SearchHeader from '../../../ui/Header/SearchHeader';
import { ScrollUp, ToggleViewMode } from '../../../ui/Controls';
import { SubscriptionSearchForm } from '../../../ui/Controls/Subscriptions';
import AdFoxFactory from '../../../ui/AdFox/AdFoxFactory';
import clientConfig from '../../../../etc/client-config.json';
import {
  gtagPushEventNewPage,
  getCianDealType,
  getCianObjectType,
  getExtraCategory,
  getCustomUrlCian
} from '../../../utils/googleAnalytics';
import GtagBuilder from '../../../classes/builder/gtagEventBuilder';

class Search extends Component {
  constructor (props) {
    super(props);

    this.state = {
      /* открыта или закрыта панель на карте */
      isCloseMapList: false,
      /* выбранные параметра фильтра */
      filter: DEFAULT_FILTER.map((_, key) => props.filter.get(key)),
      /* предыдущее значение фильтра - для минимизации рендера */
      prevFilter: props.filter
    };

    this.dealType = props.dealType;
    this.realtyType = props.realtyType;
    this.seoTitle = props.defaultSeoTitle;
    this.seoDescription = props.defaultSeoDescription;
    this.domain = props.domain;

    this.listItem = getListItem(this.dealType, this.realtyType);
    this.flexItem = getFlexItem(this.dealType, this.realtyType);

    this.handlerUpdateSort = this.handlerUpdateSort.bind(this);
    this.handlerToggleMapList = this.handlerToggleMapList.bind(this);
    this.handlerShowContacts = this.handlerShowContacts.bind(this);
    this.handlerClickAnnouncement = this.handlerClickAnnouncement.bind(this);
    this.handlerClickSubscription = this.handlerClickSubscription.bind(this);
    this.handlerAddFavorites = this.handlerAddFavorites.bind(this);
    this.handlerRemoveFavorites = this.handlerRemoveFavorites.bind(this);
    this.onPageChange = this.onPageChange.bind(this);

    /* обновляет фильтр в internal state */
    this.onUpdateFilterState = this.onUpdateFilterState.bind(this);
    this.onSubmitFilterState = this.onSubmitFilterState.bind(this);
    this.onApplyFilterState = this.onApplyFilterState.bind(this);
    this.onResetFilterState = this.onResetFilterState.bind(this);

    this.timeOutSubscription = null;
  }

  /**
   * Обновляет фильтр в internal state
   * @param filter
   * @param callback
   */
  onUpdateFilterState (filter, callback = null) {
    if (filter.page === undefined && filter.viewMode === undefined) {
      filter.page = 1;
    }

    const originalFilter = this.state.filter;
    const regionId = originalFilter.get('regionId', null) || this.domain.get('regionId');
    const localityId = originalFilter.get('localityId', null) || this.domain.get('localityId', null);
    const token = this.props.user.get('token', null);
    const filterCounter = originalFilter
        .merge(filter)
        .set('regionId', regionId)
        .set('localityId', localityId)
        .set('token', token);
    this.props.loadCountAnnouncement(this.dealType, this.realtyType, filterCounter.toJS());

    this.setState({
      filter: originalFilter.merge(filter)
    }, callback || (() => {}));
  }

  /**
   * Применяет фильтр из internal state
   */
  onSubmitFilterState () {
    this.props.updateFilter(this.state.filter);

    const location = getLocationByFilter(this.state.filter, this.dealType, this.realtyType);

    this.props.dispatch(push(location));
  }

  /**
   * Обновляет новый фильтр в internal state и применяет изменения
   * @param filter
   */
  onApplyFilterState (filter) {
    this.onUpdateFilterState(filter, this.onSubmitFilterState);
  }

  /**
   * Очищает все выбранные фильтры internal state
   */
  onResetFilterState () {
    let filter = DEFAULT_FILTER.remove('isMls').remove('sort');

    if (this.state.filter.get('viewMode') === VIEW_MODE.map) {
      filter = filter.remove('bounds').remove('areaPolygon');
    }

    filter = filter.remove('viewMode');

    this.onApplyFilterState(filter);
  }

  shouldComponentUpdate (nextProps, nextState, nextContext) {
    return !this.props.announcementList.equals(nextProps.announcementList) ||
      !this.props.announcementListMap.equals(nextProps.announcementListMap) ||
      this.props.announcementLoading !== nextProps.announcementLoading ||
      !this.props.user.equals(nextProps.user) ||
      !this.props.filter.equals(nextProps.filter) ||
      !this.props.meta.equals(nextProps.meta) ||
      this.state.isCloseMapList !== nextState.isCloseMapList ||
      !this.state.filter.equals(nextState.filter) ||
      !this.props.filteredOfferCount !== nextProps.filteredOfferCount;
  }

  componentDidMount () {
    this.props.setSection(this.dealType, this.realtyType);

    const filter = this.state.filter;
    if (filter.get('viewMode') === VIEW_MODE.map && !this.props.announcementListMap.size) {
      const regionId = filter.get('regionId', null) || this.domain.get('regionId');
      const localityId = filter.get('localityId', null) || this.domain.get('localityId', null);
      const token = this.props.user.get('token', null);

      this.props.loadAnnouncementMap(
          this.dealType,
          this.realtyType,
          filter
              .set('fields', 'id')
              .set('expand', 'lon,lat')
              .set('per-page', 1000)
              .set('regionId', regionId)
              .set('localityId', localityId)
              .set('page', 1)
              .set('token', token)
              .toJS()
      );
    }
    if (this.props.announcementList.size) {
      const cianGtagEvent = new GtagBuilder({})
        .setEvent('newpage')
        .setEventCategory('page')
        .setEventAction('newpage')
        .setEventLabel('open')
        .setUser(this.props.user)
        .setPage({
          pageType: 'Listing',
          siteType: 'desktop',
          listingType: filter.get('viewMode') === VIEW_MODE.map ? 'map' : filter.get('viewMode') === VIEW_MODE.paper ? 'table' : 'list',
          dealType: getCianDealType(this.dealType),
          objectType: getCianObjectType(this.realtyType),
          sortType: filter.get('sort') ? filter.get('sort') : 'default',
          region: this.props.domain.get('regionName').replace(/\.$/, ''),
          offersQty: this.props.meta.get('totalCount'),
          pageNumber: Number(this.props.filter.get('page')),
          extra: {
            category: getExtraCategory(this.dealType, this.realtyType)
          }
        })
        .setProducts(this.props.announcementList)
        .getEvent();
      gtagPushEventNewPage(cianGtagEvent);
    }
  }

  static getDerivedStateFromProps (props, state) {
    if (!state.prevFilter || !state.prevFilter.equals(props.filter)) {
      return {
        filter: DEFAULT_FILTER.map((_, key) => props.filter.get(key)),
        prevFilter: props.filter
      };
    }

    return null;
  }

  componentDidUpdate (prevProps, prevState, prevContext) {
    if (this.props.filter && !this.props.filter.equals(prevProps.filter)) {
      const isReloadList = this.allowReloadAnnouncementList(this.props.filter, prevProps.filter);
      const isReloadMap = this.allowReloadAnnouncementMap(this.props.filter, prevProps.filter);
      this.reloadAnnouncement(isReloadList, isReloadMap);
      if ((prevProps.filter.get('viewMode') === VIEW_MODE.grid && this.props.filter.get('viewMode') === VIEW_MODE.paper && !isReloadList && !isReloadMap) ||
          (prevProps.filter.get('viewMode') === VIEW_MODE.paper && this.props.filter.get('viewMode') === VIEW_MODE.grid && !isReloadList && !isReloadMap)) {
        const cianGtagEvent = new GtagBuilder({})
          .setEvent('newpage')
          .setEventCategory('page')
          .setEventAction('newpage')
          .setEventLabel('open')
          .setUser(this.props.user)
          .setPage({
            pageType: 'Listing',
            siteType: 'desktop',
            listingType: this.props.filter.get('viewMode') === VIEW_MODE.map ? 'map' : this.props.filter.get('viewMode') === VIEW_MODE.paper ? 'table' : 'list',
            dealType: getCianDealType(this.dealType),
            objectType: getCianObjectType(this.realtyType),
            sortType: this.props.filter.get('sort') ? this.props.filter.get('sort') : 'default',
            region: this.props.domain.get('regionName').replace(/\.$/, ''),
            offersQty: this.props.meta.get('totalCount'),
            pageNumber: Number(this.props.filter.get('page')),
            extra: {
              category: getExtraCategory(this.dealType, this.realtyType)
            }
          })
          .setProducts(this.props.announcementList)
          .getEvent();
        gtagPushEventNewPage(cianGtagEvent);
      }
    }

    ReactTooltip.rebuild();
  }

  componentWillUnmount () {
    this.props.resetFilter();
    this.timeOutSubscription && clearTimeout(this.timeOutSubscription);
  }

  allowReloadAnnouncementList (filter, prevFilter) {
    if (filter.get('viewMode') === VIEW_MODE.map && this.state.isCloseMapList) {
      return false;
    }

    if (prevFilter.get('viewMode') === VIEW_MODE.grid && filter.get('viewMode') === VIEW_MODE.paper) {
      return false;
    }

    if (prevFilter.get('viewMode') === VIEW_MODE.paper && filter.get('viewMode') === VIEW_MODE.grid) {
      return false;
    }

    return true;
  }

  allowReloadAnnouncementMap (filter, prevFilter) {
    let newParams = filter.slice();

    prevFilter.map((val, key) => {
      if (newParams.get(key) === val) {
        newParams = newParams.remove(key);
      }
    });

    const onlyPage = newParams.keySeq().toList().equals(new List(['page']));
    const onlyPerPage = newParams.keySeq().toList().equals(new List(['per-page']));

    if (filter.get('viewMode') === VIEW_MODE.map && !onlyPage && !onlyPerPage) {
      return true;
    }
  }

  reloadAnnouncement (isReloadList, isReloadMap) {
    const filter = this.state.filter;
    const regionId = filter.get('regionId', null) || this.domain.get('regionId');
    const localityId = filter.get('localityId', null) || this.domain.get('localityId', null);
    const token = this.props.user.get('token', null);

    if (isReloadList) {
      this.props.loadAnnouncement(
        this.dealType,
        this.realtyType,
        filter
          .set('regionId', regionId)
          .set('localityId', localityId)
          .set('token', token)
          .toJS()
      );
    }

    if (isReloadMap) {
      this.props.loadAnnouncementMap(
        this.dealType,
        this.realtyType,
        filter
          .set('fields', 'id')
          .set('expand', 'lon,lat')
          .set('per-page', 1000)
          .set('regionId', regionId)
          .set('localityId', localityId)
          .set('page', 1)
          .set('token', token)
          .toJS()
      );
    }
  }

  showDynamic () {
    const regionId = parseInt(this.props.domain.get('regionId'));
    return (regionId === 55 || regionId === 16) && this.dealType === SALE && this.realtyType === APARTMENTS;
  }

  /**
   * Обработчик сортировки
   * @param e
   */
  handlerUpdateSort (e) {
    this.onApplyFilterState({sort: e.target.dataset.sortkey});
  }

  handlerToggleMapList () {
    this.setState(
      {isCloseMapList: !this.state.isCloseMapList},
      () => setTimeout(() => window.dispatchEvent(new Event('resize')), 500)
    );
  }

  handlerShowContacts (announcement) {
    const { domain, meta, filter } = this.props;
    eventShowContacts();
    const cianGtagEvent = new GtagBuilder({})
      .setEvent('oldevent')
      .setEventCategory('Phones')
      .setEventAction(filter.get('viewMode') === VIEW_MODE.paper ? 'Open_table' : 'Open_listing')
      .setEventLabel(getCustomUrlCian(announcement))
      .setUser(this.props.user)
      .setPage({
        pageType: 'Listing',
        siteType: 'desktop',
        listingType: filter.get('viewMode') === VIEW_MODE.map ? 'map' : filter.get('viewMode') === VIEW_MODE.paper ? 'table' : 'list',
        dealType: getCianDealType(announcement.get('dealType')),
        objectType: getCianObjectType(announcement.get('realtyType')),
        sortType: filter.get('sort') ? filter.get('sort') : 'default',
        region: domain.get('regionName').replace(/\.$/, ''),
        offersQty: meta.get('totalCount'),
        pageNumber: Number(filter.get('page')),
        extra: {
          category: getExtraCategory(this.dealType, this.realtyType)
        }
      })
      .setProducts(new List([announcement]))
      .getEvent();
    gtagPushEventNewPage(cianGtagEvent);
  }

  handlerAddFavorites (announcement) {
    const { domain, meta, filter } = this.props;
    const cianGtagEvent = new GtagBuilder({})
      .setEvent('oldevent')
      .setEventCategory('favorite')
      .setEventAction('add_from_list')
      .setEventLabel(getCustomUrlCian(announcement))
      .setUser(this.props.user)
      .setPage({
        pageType: 'Listing',
        siteType: 'desktop',
        listingType: 'list',
        dealType: getCianDealType(announcement.get('dealType')),
        objectType: getCianObjectType(announcement.get('realtyType')),
        sortType: filter.get('sort') ? filter.get('sort') : 'default',
        region: domain.get('regionName').replace(/\.$/, ''),
        offersQty: meta.get('totalCount'),
        pageNumber: Number(filter.get('page')),
        extra: {
          category: getExtraCategory(this.dealType, this.realtyType)
        }
      })
      .setProducts(new List([announcement]))
      .getEvent();
    gtagPushEventNewPage(cianGtagEvent);
  }

  handlerRemoveFavorites (announcement) {
    const { domain, meta, filter } = this.props;
    const cianGtagEvent = new GtagBuilder({})
      .setEvent('oldevent')
      .setEventCategory('favorite')
      .setEventAction('remove_from_list')
      .setEventLabel(getCustomUrlCian(announcement))
      .setUser(this.props.user)
      .setPage({
        pageType: 'Listing',
        siteType: 'desktop',
        listingType: 'list',
        dealType: getCianDealType(announcement.get('dealType')),
        objectType: getCianObjectType(announcement.get('realtyType')),
        sortType: filter.get('sort') ? filter.get('sort') : 'default',
        region: domain.get('regionName').replace(/\.$/, ''),
        offersQty: meta.get('totalCount'),
        pageNumber: Number(filter.get('page')),
        extra: {
          category: getExtraCategory(this.dealType, this.realtyType)
        }
      })
      .setProducts(new List([announcement]))
      .getEvent();
    gtagPushEventNewPage(cianGtagEvent);
  }

  handlerClickAnnouncement (announcement) {
    const { domain, meta, filter } = this.props;
    const cianGtagEvent = new GtagBuilder({})
      .setEvent('oldevent')
      .setEventCategory('Listing')
      .setEventAction('to_card')
      .setEventLabel(filter.get('viewMode') === VIEW_MODE.map ? 'from_listing_in_map' : 'from_listing')
      .setUser(this.props.user)
      .setPage({
        pageType: 'Listing',
        siteType: 'desktop',
        listingType: filter.get('viewMode') === VIEW_MODE.map ? 'map' : filter.get('viewMode') === VIEW_MODE.paper ? 'table' : 'list',
        dealType: getCianDealType(announcement.get('dealType')),
        objectType: getCianObjectType(announcement.get('realtyType')),
        sortType: filter.get('sort') ? filter.get('sort') : 'default',
        region: domain.get('regionName').replace(/\.$/, ''),
        offersQty: meta.get('totalCount'),
        pageNumber: Number(filter.get('page')),
        extra: {
          category: getExtraCategory(this.dealType, this.realtyType)
        }
      })
      .setProducts(new List([announcement]))
      .getEvent();
    gtagPushEventNewPage(cianGtagEvent);
  }

  handlerClickSubscription () {
    const {
      domain,
      meta,
      filter,
      announcementListMap,
      announcementList
    } = this.props;
    let eventLabel = 'From_listing';
    if ((filter.get('viewMode') === VIEW_MODE.map && !announcementListMap.size) ||
        (filter.get('viewMode') !== VIEW_MODE.map && !announcementList.size)) {
      eventLabel = 'From_empty';
    } else {
      eventLabel = filter.get('viewMode') === VIEW_MODE.map ? 'From_map' : filter.get('viewMode') === VIEW_MODE.paper ? 'From_table' : 'From_listing';
    }
    const cianGtagEvent = new GtagBuilder({})
      .setEvent('oldevent')
      .setEventCategory('subscription')
      .setEventAction('Send')
      .setEventLabel(eventLabel)
      .setUser(this.props.user)
      .setPage({
        pageType: 'Listing',
        siteType: 'desktop',
        listingType: filter.get('viewMode') === VIEW_MODE.map ? 'map' : filter.get('viewMode') === VIEW_MODE.paper ? 'table' : 'list',
        dealType: getCianDealType(this.dealType),
        objectType: getCianObjectType(this.realtyType),
        sortType: filter.get('sort') ? filter.get('sort') : 'default',
        region: domain.get('regionName').replace(/\.$/, ''),
        offersQty: meta.get('totalCount'),
        pageNumber: Number(filter.get('page')),
        extra: {
          category: getExtraCategory(this.dealType, this.realtyType)
        }
      })
      .getEvent();
    gtagPushEventNewPage(cianGtagEvent);
  }

  /**
   * Обработчик пагинатора
   * @param filter
   */
  onPageChange (filter) {
    const selected = parseInt(this.state.filter.get('page'));
    const page = (parseInt(filter.selected) || 0) + 1;
    window.scrollTo(0, 0);
    if (selected !== page) {
      this.onApplyFilterState({page});
    }
  }

  renderSeo () {
    const {meta, routLocation, domain} = this.props;
    const title = meta && meta.get('seoTitle');
    const description = meta && meta.get('seoDescription');
    const keywords = meta && meta.get('seoKeywords');

    const currentPage = meta.get('currentPage');
    const totalPage = meta.get('pageCount');
    const path = `${clientConfig.protocol}://${domain.get('domain')}.${clientConfig.rootDomain}${routLocation.get('pathname')}`;
    const search = routLocation.get('search');

    return (
      <Helmet
        htmlAttributes={{ lang: 'ru' }}
        title={title || this.seoTitle + ' - сайт недвижимости МЛСН.ру'}
        meta={[
          {
            'name': 'description',
            'content': description || this.seoDescription
          }, {
            'name': 'keywords',
            'content': keywords
          }
        ]}
        link={[
          {
            'rel': 'prev',
            'href': getPrevRelPage(currentPage, search)
          },
          {
            'rel': 'next',
            'href': getNextRelPage(currentPage, totalPage, search)
          }
        ].filter(item => item.href !== false).map(item => (item.href = path + item.href) && item)}
      />
    );
  }

  renderSearchResult (viewMode) {
    const filter = this.state.filter;
    const {meta, dealType, realtyType, domain, user, dictionary, announcementList} = this.props;
    const regionName = domain.get('domain', '') || '';
    const QuickFilter = this.props.quickFilter;
    const adFoxFooter = AdFoxFactory(regionName).getBySection(ADFOX.listingFooter, dealType, realtyType);

    const pageText = meta.get('seoText');

    const cellFactory = getCellSearchFactory(viewMode, user, domain);
    const tableFactory = getTableSearchFactory(viewMode, dealType, realtyType);

    return (
      <section className='search-result' id='search-result-section'>
        <SearchHeader
          title={meta.get('h1') || meta.get('seoTitle')}
          totalCount={meta.get('totalCount')}
          avgPrice={meta.get('avgPrice')}
          avgPricePerSquareMeter={meta.get('avgPricePerSquareMeter')}
          showDynamic={this.showDynamic()}
          filter={filter}

          eventSaveSearch={eventSaveSearch}
          eventSubscription={eventSubscription}
          eventSubscriptionForCian={this.handlerClickSubscription}
        />

        {
          QuickFilter &&
          (
            <div className='quick-filter no-print'>
              <QuickFilter
                user={user}
                domain={domain}
                filter={filter}
                dictionary={dictionary}

                onUpdate={this.onApplyFilterState}
              />
            </div>
          )
        }

        {
          announcementList.size || this.props.announcementLoading
          ? (
            <div style={{minHeight: '250px'}}>
              {viewMode === VIEW_MODE.paper &&
                <GridView
                  domain={domain}
                  user={user}

                  sortKey={filter.get('sort')}
                  onSort={this.handlerUpdateSort}
                  tableFactory={tableFactory}
                  cellFactory={cellFactory}

                  isLoading={this.props.announcementLoading}

                  dealType={dealType}
                  realtyType={realtyType}
                  data={announcementList}
                  dictionary={dictionary}
                  onUpdateFilter={this.onApplyFilterState}

                  className={'mode-' + viewMode}
                  isBordered={viewMode !== VIEW_MODE.paper}

                  eventAddFavorites={eventAddFavorites}
                  eventRemoveFavorites={eventRemoveFavorites}
                  eventOpenCommentForm={eventOpenCommentForm}
                  eventOpenClaimForm={eventOpenClaimForm}
                  eventMapModal={eventMapModal}
                  eventShowContacts={this.handlerShowContacts}
                  eventClickAnnouncement={this.handlerClickAnnouncement}
                />
              }

              {viewMode !== VIEW_MODE.paper && viewMode !== VIEW_MODE.map &&
                <FlexView
                  flexItem={this.flexItem}
                  isLoading={this.props.announcementLoading}
                  data={this.props.announcementList}
                  dealType={dealType}
                  realtyType={realtyType}
                  domain={domain}
                  user={user}
                  dictionary={dictionary}
                  onUpdateFilter={this.onApplyFilterState}

                  tableFactory={tableFactory}
                  cellFactory={cellFactory}

                  sortKey={filter.get('sort')}
                  onSort={this.handlerUpdateSort}

                  eventAddFavorites={eventAddFavorites}
                  eventRemoveFavorites={eventRemoveFavorites}
                  eventAddFavoritesForCian={this.handlerAddFavorites}
                  eventRemoveFavoritesForCian={this.handlerRemoveFavorites}
                  eventOpenCommentForm={eventOpenCommentForm}
                  eventOpenClaimForm={eventOpenClaimForm}
                  eventMapModal={eventMapModal}
                  eventShowContacts={this.handlerShowContacts}
                  eventClickAnnouncement={this.handlerClickAnnouncement}
                />
              }

              {
                !!announcementList.size && (
                  <div className='pagination-wrp'>
                    <ReactPaginate
                      onPageChange={this.onPageChange}
                      pageCount={meta.get('pageCount')}
                      initialPage={meta.get('currentPage') - 1}
                      forcePage={meta.get('currentPage') - 1}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      disableInitialCallback
                      previousLabel={
                        (
                          <Fragment>
                            <span className="icon-arrow-left-new"></span>
                            <span>В начало</span>
                          </Fragment>
                        )
                      }
                      nextLabel={
                        (
                          <Fragment>
                            <span>Следующая</span>
                            <span className="icon-arrow-right-new"></span>
                          </Fragment>
                        )
                      }
                    />
                  </div>
                )
              }

              { !this.props.announcementLoading && adFoxFooter }

              {
                (dealType === SALE || dealType === RENT) && realtyType === APARTMENTS &&
                !filter.get('isDealCompleted') &&
                parseInt(filter.get('page')) === meta.get('pageCount') &&
                <SoldAnnouncement
                  dealType={dealType}
                  realtyType={realtyType}
                  tableFactory={tableFactory}
                  cellFactory={cellFactory}
                  dictionary={dictionary}
                  onUpdateFilter={this.onApplyFilterState}
                  flexItem={this.flexItem}

                  className={'mode-' + viewMode}
                  isBordered={viewMode !== VIEW_MODE.paper}
                />
              }

            </div>
            )
          : (
            <div className='empty-result'>
              По вашему запросу ничего не найдено. <br /><br />
              Попробуйте изменить параметры поиска<br />
              {
                filter.get('isDealCompleted') ? null : (
                  <div>
                    или <br />
                    <SubscriptionSearchForm eventOnOpen={eventSubscription} filter={this.state.filter}>
                      <span className='btn-base btn-underline'>подписаться на новые объявления</span>
                    </SubscriptionSearchForm>
                  </div>
                )
              }
            </div>
          )
        }

        { <SeoText text={pageText} /> }

      </section>
    );
  }

  renderMap () {
    const { meta, domain, user, dealType, realtyType, dictionary } = this.props;
    const { filter } = this.state;

    const addressHash =
        filter.get('houseId', '') + '_' +
        filter.get('streetId', '') + '_' +
        filter.get('localityId', '') + '_' +
        filter.get('address', '');

    return (
      <section id='map-result' className='map-result'>
        <ScrollToTopOnMount />
        <FixedBody disable_margin />
        <div className='map-result-wrp'>
          <ToggleViewMode
            className='map-toggle-view-mode'
            viewMode={filter.get('viewMode')}
            onUpdate={this.onApplyFilterState}
          />

          <MapView
            addressHash={addressHash}
            bounds={filter.get('bounds')}
            areaPolygon={filter.get('areaPolygon')}
            domain={domain}
            user={user}

            isDealCompleted={!!filter.get('isDealCompleted')}
            dealType={dealType}
            realtyType={realtyType}
            data={this.props.announcementList}
            points={this.props.announcementListMap}
            meta={meta}
            dictionary={dictionary}
            onUpdateFilter={this.onApplyFilterState}
          />
        </div>

        <div className={'list-view-result-wrp' + (this.state.isCloseMapList ? ' width-0' : '')}>
          <div
            className='toogle-list-width'
            onClick={this.handlerToggleMapList}
          />
          <SearchHeader
            title={meta.get('h1') || meta.get('seoTitle')}
            totalCount={meta.get('totalCount')}
            avgPrice={meta.get('avgPrice')}
            avgPricePerSquareMeter={meta.get('avgPricePerSquareMeter')}
            showDynamic={false}
            filter={filter}

            eventSaveSearch={eventSaveSearch}
            eventSubscription={eventSubscription}
            eventSubscriptionForCian={this.handlerClickSubscription}
          />
          <ListView
            listItem={this.listItem}
            isLoading={this.props.announcementLoading}
            data={this.props.announcementList}
            dealType={dealType}
            realtyType={realtyType}
            domain={domain}
            user={user}
            dictionary={dictionary}
            onUpdateFilter={this.onApplyFilterState}
            eventClickAnnouncement={this.handlerClickAnnouncement}
          />
          <div className='pagination-wrp'>
            <ReactPaginate
              onPageChange={this.onPageChange}
              marginPagesDisplayed={1}
              pageCount={meta.get('pageCount')}
              initialPage={meta.get('currentPage') - 1}
              forcePage={meta.get('currentPage') - 1}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              disableInitialCallback
              previousLabel={
                (
                  <Fragment>
                    <span className="icon-arrow-left-new map"></span>
                  </Fragment>
                )
              }
              nextLabel={
                (
                  <Fragment>
                    <span className="icon-arrow-right-new map"></span>
                  </Fragment>
                )
              }
            />
          </div>
        </div>
      </section>
    );
  }

  render () {
    const QuickSearch = this.props.quickSearch;
    const {
      user,
      domain,
      dictionary,
      dealType,
      realtyType,
      selectedOptions,
      agenciesList,
      filteredOfferCount,
      updateAutocompleteOptions,
    } = this.props;

    const { filter, prevFilter } = this.state;
    const viewMode = this.state.filter.get('viewMode');

    return (
      <div className='search-page'>
        { this.renderSeo() }

        <ScrollToTopOnMount />

        { viewMode !== VIEW_MODE.map &&
          <AdFoxWideScreen
            position={ADFOX.topWideScreenSearch}
            regionName={domain.get('domain', '') || ''}
            dealType={dealType}
            realtyType={realtyType}
            isHide={viewMode === VIEW_MODE.map}
          />
        }

        <div className='quick-search-wrp no-print' id='quick-search-menu-stick'>
          <div className='quick-search'>
            <QuickSearch
              user={user}
              domain={domain}
              filter={filter}
              prevFilter={prevFilter}
              dictionary={dictionary}
              offerCount={filteredOfferCount}
              agenciesList={agenciesList}
              selectedOptions={selectedOptions}
              updateAutocompleteOptions={updateAutocompleteOptions}

              onApply={this.onApplyFilterState}
              onUpdate={this.onUpdateFilterState}
              onSubmit={this.onSubmitFilterState}
              onReset={this.onResetFilterState}
            />
          </div>
        </div>

        { viewMode === VIEW_MODE.map ? this.renderMap() : this.renderSearchResult(viewMode) }

        <ScrollUp showUnder={500} />
        <FixedMenu id='quick-search-menu-stick' searchSectionId={viewMode === VIEW_MODE.map ? 'map-result' : 'search-result-section' } />
      </div>
    );
  }
}

Search.propTypes = {
  filteredOfferCount: PropTypes.number,
  quickFilter: PropTypes.func,
  quickSearch: PropTypes.func.isRequired,
  domain: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  routLocation: PropTypes.object.isRequired,

  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,
  defaultSeoTitle: PropTypes.string,
  defaultSeoDescription: PropTypes.string,

  dictionary: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  announcementList: PropTypes.object.isRequired,
  announcementListMap: PropTypes.object.isRequired,
  announcementLoading: PropTypes.bool,
  meta: PropTypes.object,

  resetFilter: PropTypes.func.isRequired,
  updateFilter: PropTypes.func.isRequired,
  loadCountAnnouncement: PropTypes.func.isRequired,
  loadAnnouncement: PropTypes.func.isRequired,
  loadAnnouncementMap: PropTypes.func.isRequired,
  setSection: PropTypes.func.isRequired,

  agenciesList: PropTypes.object.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  updateAutocompleteOptions: PropTypes.func.isRequired,
};

Search.defaultProps = {
  filteredOfferCount: 0,
  quickFilter: null,
  defaultSeoTitle: 'Поиск объявлений',
  defaultSeoDescription: 'Поиск объявлений',
  announcementLoading: true,
  meta: new Map(),
  selectedOptions: [],
};

function mapStateToProps (state) {
  const search = state.get('search');

  return {
    filteredOfferCount: search.get('filteredOfferCount') || 0,
    routLocation: state.getIn(['routing', 'location']),
    domain: state.get('domain'),
    user: state.get('user'),
    filter: search.get('filter'),
    meta: search.get('meta'),
    announcementList: search.get('announcementList'),
    announcementLoading: !!search.get('loading'),
    announcementListMap: state.getIn(['maps', 'announcement', 'announcementList'], new List()),
    dictionary: getDictionary(state.get('dictionaries')),
    agenciesList: search.get('agenciesList'),
    selectedOptions: search.get('selectedOptions').toJS() || [],
  };
}

function mapDispatchToProps (dispatch) {
  const actions = bindActionCreators({
    getUser,
    resetFilter,
    updateFilter,
    setSection,
    loadAnnouncement,
    fetchAnnouncement,
    loadCountAnnouncement,
    loadAnnouncementMap,
    fetchAgencies,
    updateAutocompleteOptions,
  }, dispatch);

  actions.dispatch = dispatch;
  return actions;
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  connectDataFetchers(Search, [ getUser, setFilterByLocation, fetchAnnouncement, fetchAgencies, getCianRedirectUrl ])
));



// WEBPACK FOOTER //
// ./src/app/Search/components/Search.jsx